import React from 'react';
import getColor from '@gc-npm/utils.enums.colors';
import IconGlyph from '@gc-npm/components.icon-glyph';
/**
 * Componente que permite crear un carrousel de icon-glyph
 */
const IconList = (props) => {
  const { cmsHandler, blockName } = props;

  const color = props.color || 'white';
  const backgroundColor = getColor(color);
  const iconList = props['cms-atom-icon-1'];

  const className = 'cms-icon-list';

  if (!iconList || !Array.isArray(iconList) || iconList.length === 0) {
    return null;
  }

  return (
    <div
      id={blockName || ''}
      className={className}
      style={{ backgroundColor }}
    >
      {cmsHandler && (
        <button
          type="button"
          className="element-editable block edit-component"
          onClick={() => cmsHandler({
            ...props,
            name: 'icon-glyph',
          })}
          aria-label="Editar lista de iconos"
        >
          <IconGlyph id="lapiz-m" height={28} color="white" />
        </button>
      )}
      <div>
        <div className="content-gap">
          <div className={`${className}--flex`}>
            {iconList.map((item, index) => (
              <IconGlyph
                {...item}
                cmsHandler={cmsHandler}
                key={`icon-${index}`}
              />
            ))}
          </div>
        </div>
      </div>

      <style jsx>
        {`
        .cms-icon-list {
          background-color: white;
          padding: 8px 0;

          &--flex {
            display: flex;
            flex-direction: row;
            gap: 0.2rem;
            flex-wrap: wrap;
          }
          @media screen and (max-width: 768px) {
            &--flex {
              display: flex;
              gap: 4px;
              height: 100%;
            }
          }
        }
      `}
      </style>
    </div>
  );
}

export default IconList;
